import { ComponentPropsWithoutRef, ReactNode } from 'react';
import { Loader } from '../Loader/Loader';
import { ButtonWrapper, ButtonContent, ButtonVariantType } from './styles';
import { Box } from '../Box/Box';

interface ButtonType extends ComponentPropsWithoutRef<'button'> {
  children?: ReactNode;
  icon?: ReactNode;
  iconPosition?: 'left' | 'right';
  onClick?: (event) => void;
  type?: 'button' | 'reset' | 'submit';
  disabled?: boolean;
  readonly?: boolean;
  width?: number | string;
  size?: 'large' | 'medium';
  variant?: ButtonVariantType;
  isLoading?: boolean;
  mobileStretch?: boolean;
}

export const Button = ({
  children,
  icon,
  iconPosition,
  onClick,
  width,
  type = 'button',
  disabled,
  readonly,
  size = 'large',
  variant = 'primary',
  isLoading = false,
  mobileStretch = false,
  ...rest
}: ButtonType) => {
  return (
    <ButtonWrapper
      type={type}
      width={width}
      onClick={type !== 'submit' ? onClick : undefined}
      disabled={disabled || isLoading}
      size={size}
      variant={variant}
      mobileStretch={mobileStretch}
      readonly={readonly}
      {...rest}
    >
      {isLoading && (
        <Box position='absolute' left={0} right={0} height='100%' zIndex={1}>
          <Loader width='100%' size={size} />
        </Box>
      )}

      <ButtonContent hasIcon={!!icon}>
        {icon && iconPosition === 'left' && <div>{icon}</div>}
        {children}
        {icon && iconPosition === 'right' && <div>{icon}</div>}
      </ButtonContent>
    </ButtonWrapper>
  );
};
